// src/App.tsx - REEMPLAZAR CONTENIDO COMPLETO

import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AppProvider } from './shared/context/AppContext';
import MainLayout from './shared/components/layout/MainLayout';
import AppRouter from './Router';

// Importar estilos globales
import './shared/styles/variables.css';
import './shared/styles/global.css';
import './shared/styles/components.css';
import './modules/competitions/styles/index.css';

// Usar la variable de entorno
const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

function App() {
  // Verificar configuración
  React.useEffect(() => {
    console.log('Configuración de la aplicación:', {
      hasGoogleClientId: !!GOOGLE_CLIENT_ID,
      apiUrl: process.env.REACT_APP_API_URL
    });

    if (!GOOGLE_CLIENT_ID) {
      console.error('REACT_APP_GOOGLE_CLIENT_ID no está configurado');
    }
    
    if (!process.env.REACT_APP_API_URL) {
      console.error('REACT_APP_API_URL no está configurado');
    }
  }, []);

  if (!GOOGLE_CLIENT_ID) {
    return (
      <div className="error-container">
        <div className="container container--sm">
          <div className="text-center">
            <h1 className="text-xl font-bold" style={{ color: 'var(--danger-color)' }}>
              Error de Configuración
            </h1>
            <p className="text-secondary" style={{ marginTop: 'var(--spacing-md)' }}>
              Las variables de entorno no están configuradas correctamente.
            </p>
            <p className="text-muted text-sm" style={{ marginTop: 'var(--spacing-sm)' }}>
              Verifica que REACT_APP_GOOGLE_CLIENT_ID esté configurado.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <AppProvider>
        <BrowserRouter>
          <div className="app">
            <MainLayout>
              <AppRouter />
            </MainLayout>
          </div>
        </BrowserRouter>
      </AppProvider>
    </GoogleOAuthProvider>
  );
}

export default App;